import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section - image + carte, même fond que les autres sections */}
      <section className="relative bg-gray-100 min-h-screen flex flex-col">
        {/* Image encore un peu plus haute : elle descend davantage derrière la carte */}
        <div className="w-full h-[70vh] min-h-[260px] overflow-hidden flex-shrink-0">
          <img
            src="/MAINS PRUDENS.png"
            alt="Prudens - bien vieillir"
            className="w-full h-full object-cover object-center"
          />
        </div>

        {/* Carte remontée sur l'image (image descend plus derrière l'encadré) */}
        <div className="relative flex-shrink-0 -mt-20 sm:-mt-24 lg:-mt-28">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto">
              <div className="bg-white rounded-3xl shadow-2xl border border-gray-200 px-6 py-8 sm:px-10 sm:py-10 text-center">
                <img
                  src="/logo.png"
                  alt="Logo Prudens"
                  className="h-20 sm:h-24 md:h-28 w-auto max-w-full object-contain mx-auto mb-4"
                />
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-prudens-bleu-fonce tracking-tight leading-tight">
                  Bien vieillir en autonomie
                </h1>
              </div>
            </div>
          </div>
        </div>

        {/* Remplit le reste de l'écran pour que "Pourquoi nous sommes là" ne soit pas visible à l'arrivée */}
        <div className="flex-1 min-h-[80px]" aria-hidden="true" />
      </section>

      {/* Pourquoi nous sommes là */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto bg-prudens-bleu-clair/10 rounded-2xl shadow-lg p-8 md:p-10">
            <h2 className="section-title text-center mb-6">Pourquoi sommes-nous là ? </h2>
            <div className="space-y-6">
              <p className="text-gray-700 text-lg">
                Face à l'enjeu de la transition démographique, le constat est sans appel : il faut redéfinir l'approche de l'habitat et des services aux séniors modestes en changeant radicalement les règles du jeu.
              </p>
              <p className="text-gray-700 text-lg">
                Notre choix est d'apporter des solutions variées, car les problématiques de chacun sont différentes. Ainsi, Prudens a développé une offre de téléconciergerie disponible à domicile pour les seniors qui souhaitent continuer à vivre chez eux.
              </p>
              <p className="text-gray-700 text-lg">
                Et pour ceux qui préfèrent rejoindre un habitat collectif et solidaire, Prudens propose des résidences de services financées par des bailleurs sociaux, accessibles aux plus modestes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Activités */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="section-title">Nos Activités</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Découvrez nos branches dédiées à l'accompagnement des personnes âgées.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="h-48 bg-prudens-bleu-clair">
                <img
                  src="/residence6.png"
                  alt="Résidence"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-prudens-bleu-fonce mb-4">Prudens Résidence</h3>
                <p className="text-gray-600 mb-6">
                  Des résidences seniors où l'autonomie se conjugue avec la sécurité et le bien-être.
                </p>
                <Link to="/residence" className="text-prudens-bleu-clair hover:text-prudens-bleu-fonce font-medium">
                  En savoir plus →
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="h-48 bg-prudens-bleu-grise">
                <img
                  src="/teleconcierge1.png"
                  alt="Téléconcierge"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-prudens-bleu-fonce mb-4">Prudens Téléconciergerie</h3>
                <p className="text-gray-600 mb-6">
                  Un service de conciergerie à distance pour faciliter le quotidien des seniors et soulager les aidants.
                </p>
                <Link to="/teleconciergerie" className="text-prudens-bleu-clair hover:text-prudens-bleu-fonce font-medium">
                  En savoir plus →
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Présentation */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="section-title">Notre ambition</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Prudens s'engage à répondre aux défis du vieillissement en proposant des solutions
              innovantes qui préservent l'autonomie et la dignité des seniors.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-xl ring-1 ring-gray-200 p-8 border-t-4 border-prudens-bleu-clair">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-prudens-bleu-clair/10 rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-prudens-bleu-clair" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-prudens-bleu-fonce">Approche humaine</h3>
              </div>
              <p className="text-gray-600">
                Nous plaçons l'humain au centre de toutes nos solutions. La technologie est au service
                du bien-être et des relations sociales.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-xl ring-1 ring-gray-200 p-8 border-t-4 border-prudens-rouge-doux">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-prudens-rouge-doux/10 rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-prudens-rouge-doux" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-prudens-bleu-fonce">Innovation adaptée</h3>
              </div>
              <p className="text-gray-600">
                Nos solutions innovantes sont conçues spécifiquement pour répondre aux besoins réels
                des seniors et leurs aidants.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
